export default {
  noInternetMessage: { id: 'no_internet_message' },
}
